<template>
  <div class="vessel-management-container">
    <div class="page-header flex items-center mb-4">
      <el-page-header @back="goBack" :content="pageTitle"></el-page-header>
    </div>

    <div class="form-container bg-white p-6 rounded shadow-sm">
      <el-form 
        ref="vesselForm" 
        :model="vesselForm" 
        :rules="rules" 
        label-width="120px"
        :disabled="viewMode"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="船舶名称" prop="vesselName">
              <el-input v-model="vesselForm.vesselName" placeholder="请输入船舶名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="中文名称" prop="cnName">
              <el-input v-model="vesselForm.cnName" placeholder="请输入中文名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="MMSI号" prop="mmsi">
              <el-input v-model="vesselForm.mmsi" placeholder="请输入MMSI号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="呼号" prop="callSign">
              <el-input v-model="vesselForm.callSign" placeholder="请输入呼号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="船舶类型" prop="vesselType">
              <el-input v-model="vesselForm.vesselType" placeholder="请输入船舶类型"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="船旗国" prop="flag">
              <el-input v-model="vesselForm.flag" placeholder="请输入船旗国"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="船舶长度(米)" prop="length">
              <el-input-number v-model="vesselForm.length" :precision="2" :min="0" :step="0.1" :max="999.99" controls-position="right"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="船舶宽度(米)" prop="width">
              <el-input-number v-model="vesselForm.width" :precision="2" :min="0" :step="0.1" :max="999.99" controls-position="right"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="吃水深度(米)" prop="depth">
              <el-input-number v-model="vesselForm.depth" :precision="2" :min="0" :step="0.1" :max="99.99" controls-position="right"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="载重量(吨)" prop="load">
              <el-input-number v-model="vesselForm.load" :min="0" controls-position="right"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系人" prop="contacts">
              <el-input v-model="vesselForm.contacts" placeholder="请输入联系人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="contactNumber">
              <el-input v-model="vesselForm.contactNumber" placeholder="请输入联系电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-form-item label="备注信息" prop="remark">
          <el-input type="textarea" v-model="vesselForm.remark" rows="4" placeholder="请输入备注信息"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button v-if="!viewMode" type="primary" @click="submitForm">保存</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getVesselById, createVessel, updateVessel } from '@/api/vessel'

export default {
  name: 'VesselManagement',
  data() {
    return {
      vesselId: null,
      viewMode: false,
      isNewVessel: false,
      vesselForm: {
        vesselName: '',
        cnName: '',
        mmsi: '',
        callSign: '',
        vesselType: '',
        flag: '',
        length: null,
        width: null,
        depth: null,
        load: null,
        contacts: '',
        contactNumber: '',
        remark: ''
      },
      rules: {
        vesselName: [
          { required: true, message: '请输入船舶名称', trigger: 'blur' }
        ],
        mmsi: [
          { required: true, message: '请输入MMSI号', trigger: 'blur' },
          { pattern: /^[0-9]{9}$/, message: 'MMSI号必须为9位数字', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    pageTitle() {
      if (this.viewMode) {
        return '查看船舶信息'
      }
      return this.isNewVessel ? '添加船舶' : '编辑船舶'
    }
  },
  created() {
    this.initFromQuery()
  },
  methods: {
    // 初始化表单数据
    initFromQuery() {
      const { id, view, actiontype } = this.$route.query
      
      if (id) {
        this.vesselId = parseInt(id)
        this.isNewVessel = false
        this.viewMode = view === 'true'
        this.fetchVesselDetail()
      } else if (actiontype === 'vessel-new') {
        this.isNewVessel = true
        this.viewMode = false
      } else {
        this.goBack()
      }
    },

    // 获取船舶详情
    async fetchVesselDetail() {
      if (!this.vesselId) return
      
      try {
        const response = await getVesselById(this.vesselId)
        if (response && response.code === 200 && response.data) {
          this.vesselForm = { ...response.data }
        } else {
          this.$message.error(response?.message || '获取船舶详情失败')
        }
      } catch (error) {
        console.error('获取船舶详情出错:', error)
        this.$message.error('获取船舶详情失败')
      }
    },

    // 提交表单
    submitForm() {
      this.$refs.vesselForm.validate(async (valid) => {
        if (valid) {
          try {
            let response
            if (this.isNewVessel) {
              response = await createVessel(this.vesselForm)
            } else {
              response = await updateVessel(this.vesselId, this.vesselForm)
            }

            if (response && response.code === 200) {
              this.$message.success(this.isNewVessel ? '添加成功' : '更新成功')
              this.goBack()
            } else {
              this.$message.error(response?.message || '操作失败')
            }
          } catch (error) {
            console.error('提交表单出错:', error)
            this.$message.error(this.isNewVessel ? '添加失败' : '更新失败')
          }
        } else {
          return false
        }
      })
    },

    // 返回列表页
    goBack() {
      this.$router.push('/vessel/list')
    }
  }
}
</script>

<style scoped>
.vessel-management-container {
  padding: 20px;
}

.form-container {
  max-width: 1200px;
}
</style> 